module.exports = __webpack_public_path__ + "img/search.24a69187.svg";